import { connect } from "react-redux";
import CreateProjectHomePageModal from "./create_project_home_page_modal";
import React from "react";
import { withRouter } from "react-router-dom"
import { fetchServices, fetchContractors } from "../../actions/service_actions";
import { submitOrder } from "../../actions/project_actions";
import { openModal } from "../../actions/modal_actions";
import { fetchCurrentUser, removeCurrentUser } from "../../actions/session_actions";
import { showToast } from "../../actions/toast_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null,
  services: state.entities.services,
  contractors: state.entities.contractors,
});

const mdp = (dispatch) => ({
  fetchServices: () => dispatch(fetchServices()),
  fetchCurrentUser: (user_id) => dispatch(fetchCurrentUser(user_id)),
  showToast: (message) => dispatch(showToast(message)),
  fetchContractors: (service_id, zipcode, search, date, time, services, appointments, timezone, photographer_index, long_shoot) => dispatch(fetchContractors(service_id, zipcode, search, date, time, services, appointments, timezone, photographer_index, long_shoot)),
  submitOrder: (data) => dispatch(submitOrder(data)),
  removeCurrentUser: () => dispatch(removeCurrentUser()),
  openModal: (modal, props) => { dispatch(openModal(modal, props)); }
});

export default withRouter(connect(msp, mdp)(CreateProjectHomePageModal));